import axios from 'axios'
import configs from '../configs'
import GenericDAO from './../generic-dao'

const failed = new Promise(resolve => { resolve(false) })

const findAll = (params) => GenericDAO.find(`/webcli/med-empresa-debito-credito-negociado/`, params)
const find = (id) => GenericDAO.find(`/webcli/med-empresa-debito-credito-negociado/${ id }/`)
const save = (dataSend) => {
    let usuario = JSON.parse(localStorage.getItem('usuario'))
    if (!usuario) return failed

    let formData = new FormData()
    Object.keys(dataSend).forEach((key) => { if (dataSend[key]) formData.append(`${key}`, dataSend[key]) })
    let metodo = dataSend.id ? "patch" : "post"
    let url = dataSend.id ? `${ configs.baseUrl }/webcli/med-empresa-debito-credito-negociado/${ dataSend.id }/` : `${ configs.baseUrl }/webcli/med-empresa-debito-credito-negociado/`
    return axios[metodo](
        url, formData,
        { headers: {'Authorization': `${ usuario.tokenType } ${ usuario.accessToken }` } }
    )
        .then(response => response)
        .catch(configs.errorHandler)
}
const remove = (id) => GenericDAO.remove(`/webcli/med-empresa-debito-credito-negociado/${ id }/`)

export default {
    find,
    findAll,
    save,
    remove,
}